<div
  class="flex flex-row items-center gap-2 rounded-md bg-slate-100 px-4 py-2 text-slate-700"
>
  <mat-icon class="shrink-0">upload_file</mat-icon>
  <div class="flex grow flex-col">
    <div class="flex flex-row items-center gap-1">No Custom Report</div>
    <div class="text-xs opacity-50">
      Upload a CSV or XLSX file to enrol entries in the Campaign Run.
    </div>
  </div>
</div>
